import nasa_potd from './nasa_potd/reducer';


export default {
  nasa_potd,

};
